import { Box, List, Stack, Typography } from '@mui/material'
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { t } from 'i18next'
import React from 'react'
import { useColors } from '../hooks/useColors';
import colors from '../theme/colors';
import CalificacionA from '../images/escudos_alto.svg'
import CalificacionB from '../images/escudos_medio_alto.svg'
import CalificacionC from '../images/escudos_medio_bajo.svg'
import CalificacionD from '../images/escudos_bajo.svg'

export function Leyenda() {

    const { getCalificationColor } = useColors()

    return (
        <List
            sx={{ maxWidth: 360, padding: 0, fontWeight: "normal" }}
            aria-label="Leyenda Etapas"
        >
            <ListItem disablePadding>
                <ListItemText primary={
                    <>
                        <Typography variant="h3" color={colors.parrafos} fontWeight={"bold"} paddingBottom={1}>
                            {t("cuestion.tituloLeyenda")}
                        </Typography>

                        <Stack flexDirection={'row'} alignContent={'center'} alignItems={'center'}>
                            <Box component={'img'} width={'24px'} height={'24px'} src={CalificacionA} alt="A" />
                            <Typography
                                variant='parrafo'
                                fontWeight={"bold"}
                                color={
                                    getCalificationColor(t("cuestion.LeyendaEtapaA"))
                                }>
                                &nbsp;- {t("cuestion.LeyendaTextoA")}
                            </Typography>
                        </Stack>

                        <Stack flexDirection={'row'} alignContent={'center'} alignItems={'center'}>
                            <Box component={'img'} width={'24px'} height={'24px'} src={CalificacionB} alt="B" />
                            <Typography
                                variant='parrafo'
                                fontWeight={"bold"}
                                color={
                                    getCalificationColor(t("cuestion.LeyendaEtapaB"))
                                }>
                                &nbsp;- {t("cuestion.LeyendaTextoB")}
                            </Typography>
                        </Stack>

                        <Stack flexDirection={'row'} alignContent={'center'} alignItems={'center'}>
                            <Box component={'img'} width={'24px'} height={'24px'} src={CalificacionC} alt="C" />
                            <Typography
                                variant='parrafo'
                                fontWeight={"bold"}
                                color={
                                    getCalificationColor(t("cuestion.LeyendaEtapaC"))
                                }>
                                &nbsp;- {t("cuestion.LeyendaTextoC")}
                            </Typography>
                        </Stack>

                        <Stack flexDirection={'row'} alignContent={'center'} alignItems={'center'}>
                            <Box component={'img'} width={'24px'} height={'24px'} src={CalificacionD} alt="D" />
                            <Typography
                                variant='parrafo'
                                fontWeight={"bold"}
                                color={
                                    getCalificationColor(t("cuestion.LeyendaEtapaD"))
                                }>
                                &nbsp;- {t("cuestion.LeyendaTextoD")}
                            </Typography>
                        </Stack>
                    </>
                } />
            </ListItem>
        </List>
    )
}
